import { Api, ModelRow, ModelSearchResult, StringUtil } from "@mcleod/core";
import { AutogenLayoutRegisterAdmin } from "./autogen/AutogenLayoutRegisterAdmin";
import {  ClickEvent, TableRow, Panel, Textbox } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";

export class RegisterAdmin extends AutogenLayoutRegisterAdmin {
    private tblRows: ModelRow[] = [];
    private selectedRow: TableRow;

    override onLoad() {
        //console.log(this);
        this.RefreshOnClick(null);
    }

/** This is an event handler for the onClick event of Refresh. */
  async RefreshOnClick(event: ClickEvent) {
    this.Refresh.busy = true;
    try {
        await Api.post("register-admin/nagent", {action: "refresh" }).then(response => {
        if( response )
        {
            //console.log( response );
            if( this.tableRegAdmin.rowCount > 0 )
                this.tableRegAdmin.clearRows();
            this.tblRows = response.data;
            //console.log("TableRow: " , this.tblRows);
            for (const row of this.tblRows) {
                //console.log(row);
                this.tableRegAdmin.addRow( row, null, { display: true, addToData: false });
            }
            this.txtCount.text = this.tblRows.length.toString(10);
        }
        else
            CommonDialogs.showMessage("Failed to refresh.", "Document Power");
      });
    } finally {
        this.Refresh.busy = false;
    }
    this.Update.enabled = false;
    this.Delete.enabled = false;
    this.Refresh.busy = false;
  }

/** This is an event handler for the onClick event of Add. */
  async AddOnClick(event: ClickEvent) {
    this.Add.busy = true;
    const panel = new Panel({ fillRow: true });
    const sname = new Textbox({ captionVisible: true, caption: "Service Name:", fillRow: true, required: true, text: "" });
    const hname = new Textbox({ captionVisible: true, caption: "Host Name:", fillRow: true, required: true, text: "" });
    const ipaddr = new Textbox({ captionVisible: true, caption: "IP Address:", fillRow: true, required: true, text: "" });
    const sport = new Textbox({ captionVisible: true, caption: "Service Port:", fillRow: true, required: true, text: "" });
    panel.add(sname);
    panel.add(hname);
    panel.add(ipaddr);
    panel.add(sport);
    //let returnValue = undefined;
    let svcname = undefined;
    let hostname = undefined;
    let ipaddress = undefined;
    let svcport = undefined;

    const dlg = CommonDialogs.createDialog(panel, { title: "Add Service", okVisible: true });
    const response = await dlg.show();
    if (response != undefined) {
        svcname = sname.text;
        hostname = hname.text;
        ipaddress = ipaddr.text;
        svcport = sport.text;

        try {
            await Api.post("register-admin/nagent", {action: "add",
                            service_name: svcname, host_name: hostname,
                            ip_address: ipaddress, port: svcport }).then(response => {
            if( response )
            {
                this.RefreshOnClick(event);
                //console.log( response );
            }
            else
                CommonDialogs.showMessage("Failed to add service: " + svcname, "Document Power");
        });
        } finally {
            this.Add.busy = false;
        }
    }
    this.Add.busy = false;
  }

/** This is an event handler for the onClick event of Update. */
  async UpdateOnClick(event: ClickEvent) {
    this.Update.busy = true;
    let svcname=null, hostname=null, ipaddress=null, svcport=null;
    if( this.selectedRow ){
        svcname = this.selectedRow.data.servicename;
        hostname = this.selectedRow.data.hostname;
        ipaddress = this.selectedRow.data.ipaddress;
        svcport = this.selectedRow.data.port;

        const panel = new Panel({ fillRow: true });
        const sname = new Textbox({ captionVisible: true, caption: "Service Name:", fillRow: true, required: true, text: svcname, enabled: false });
        const hname = new Textbox({ captionVisible: true, caption: "Host Name:", fillRow: true, required: true, text: hostname });
        const ipaddr = new Textbox({ captionVisible: true, caption: "IP Address:", fillRow: true, required: true, text: ipaddress });
        const sport = new Textbox({ captionVisible: true, caption: "Service Port:", fillRow: true, required: true, text: svcport });
        panel.add(sname);
        panel.add(hname);
        panel.add(ipaddr);
        panel.add(sport);

        const dlg = CommonDialogs.createDialog(panel, { title: "Update Service", okVisible: true });
        const response = await dlg.show();
        if (response != undefined) {
            svcname = sname.text;
            hostname = hname.text;
            ipaddress = ipaddr.text;
            svcport = sport.text;
            try {
                await Api.post("register-admin/nagent", {action: "update",
                                service_name: svcname, host_name: hostname,
                                ip_address: ipaddress, port: svcport }).then(response => {
                if( response )
                {
                    this.RefreshOnClick(event);
                    //console.log( response );
                }
                else
                    CommonDialogs.showMessage("Failed to update service:" + svcname, "Document Power");
            });
            } finally {
                this.Update.busy = false;
            }
        }
    }
    else{
        CommonDialogs.showMessage("Please select a row to update.", "Document Power");
    }
    this.Update.busy = false;
}

/** This is an event handler for the onClick event of Delete. */
  async DeleteOnClick(event: ClickEvent) {
    this.Delete.busy = true;
    let sname=null, hname=null, ipaddr=null, port=null;
    if( this.selectedRow ){
        sname = this.selectedRow.data.servicename;
        hname = this.selectedRow.data.hostname;
        ipaddr = this.selectedRow.data.ipaddress;
        port = this.selectedRow.data.port;
        const response = await CommonDialogs.showYesNo("Warning: Delete this service [" + sname + "] from register?", "Document Power");
        if( response )
        {
            try {
                await Api.post("register-admin/nagent", {action: "delete",
                                service_name: sname, host_name: hname,
                                ip_address: ipaddr, port: port }).then(response => {
                if( response )
                {
                    this.RefreshOnClick(event);
                    //console.log( response );
                }
                else
                    CommonDialogs.showMessage("Failed to delete service:" + sname, "Document Power");
            });
            } finally {
                this.Delete.busy = false;
            }
        }
    }
    else{
        CommonDialogs.showMessage("Please select a row to delete.", "Document Power");
    }
    this.Delete.busy = false;
}

/** This is an event handler for the onClick event of . */
  OnClick(event: ClickEvent) {
    this.selectedRow = this.tableRegAdmin.selectedRow;
    this.Update.enabled = true;
    this.Delete.enabled = true;
    //console.log(this.selectedRow);
  }
}
